// src/app/components/direct-debit-request-service-agreement-text/index.js
import React from 'react';
import styled from 'styled-components';

import styles from './index.css';

const DirectDebitRequestServiceAgreementTextWrapper = styled.div`${styles}`;

const DirectDebitRequestServiceAgreementText = () => (
  <DirectDebitRequestServiceAgreementTextWrapper>

    <h3>Direct Debit Request Service Agreement (DDRSA)</h3>

    <p>
      This is your Direct Debit Service Agreement with Zai Australia Pty Ltd
      {' '}
      (Zai), User IDs 342203 and 481561, ABN: 96637632645, (the Debit
      User), as agent for Pokitpal Pty Ltd to arrange a debit to your nominated account to pay for Round-Ups
      related goods and services provided by
      {' '}
      <strong><u>Boost Your Super</u></strong>
      .
    </p>

    <p>
      This debit or charge will be arranged by Zai’s financial institution and made
      through the Bulk Electronic Clearing System Framework (BECS) from your nominated account.
    </p>

    <p>
      It explains what your obligations are when undertaking a Direct Debit
      arrangement with us. It also details what our obligations are to you
      as your Direct Debit provider.
    </p>

    <p>
      Please keep this agreement for future reference. It forms part of the
      terms and conditions of your Direct Debit Request (DDR) and should be
      read in conjunction with your DDR authorisation.
    </p>

    <h3>Definitions</h3>

    <p>
      <strong>account</strong>
      {' '}
      means the account held at your financial institution from which we are
      authorised to arrange for funds to be debited.
    </p>

    <p>
      <strong>agreement</strong>
      {' '}
      means this Direct Debit Request Service Agreement between you and us.
    </p>

    <p>
      <strong>banking day</strong>
      {' '}
      means a day other than a Saturday or a Sunday or a public holiday
      listed throughout Australia.
    </p>

    <p>
      <strong>debit day</strong>
      {' '}
      means the day that payment by you to us is due.
    </p>

    <p>
      <strong>debit payment</strong>
      {' '}
      means a particular transaction where a debit is made.
    </p>

    <p>
      <strong>direct debit request</strong>
      {' '}
      means the Direct Debit Request between us and you.
    </p>

    <p>
      <strong>us or we</strong>
      {' '}
      means Zai Australia Pty Ltd (the Debit User), acting on behalf of
      {' '}
      <strong><u>Boost Your Super</u></strong>
      {' '}
      whom you have authorised by requesting a Direct Debit Request.
    </p>

    <p>
      <strong>you</strong>
      {' '}
      means the customer who has signed or authorised by other means the
      Direct Debit Request.
    </p>

    <p>
      <strong>your financial institution</strong>
      {' '}
      means the financial institution nominated by you on the DDR at which
      the account is maintained.
    </p>

    <p>
      <strong><u>Boost Your Super</u></strong>
      {' '}
      means the party that provides the services you are paying for, by way
      of requesting us to process your valid Debit payment instructions.
    </p>

    <p>
      <strong><u>Boost Your Super Apps</u></strong>
      {' '}
      means the provider of the software applications that collect valid
      instructions authorised by
      {' '}
      <strong><u>Boost Your Super</u></strong>
      {' '}
      and you. These instructions are provided to us to enable the
      processing of related debit payments instructions.
    </p>

    <h3>Debiting your account</h3>

    <p>
      1.1 By submitting a Direct Debit Request, you have authorised us to
      arrange for funds to be debited from your account. The Direct Debit
      Request and this agreement set out the terms of the arrangement
      between us and you.
    </p>

    <p>
      1.2 We will only arrange for funds to be debited from your account as
      authorised in the Direct Debit Request.
    </p>

    <p>
      1.3 If the debit day falls on a day that is not a banking day, we may
      direct your financial institution to debit your account on the
      following banking day. If you are unsure about which day your account
      has or will be debited you should ask your financial institution.
    </p>

    <h3>Amendments by us</h3>

    <p>
      2.1 We may vary any details of this agreement or a Direct Debit
      Request at any time by giving you at least 30 days written notice
      sent to the preferred email or address you have given us in the
      Direct Debit Request.
    </p>

    <h3>Amendments by you</h3>

    <p>3.1 You can at any time by giving us 5 days notice:</p>

    <p>(a) cancel or suspend the Direct Debit Request; or</p>
    <p>(b) change, stop or defer an individual debit payment;</p>

    <p>To do so, you can:</p>

    <p>
      (i) update your instructions using the
      {' '}
      <strong><u>Boost Your Super</u></strong>
      {' '}
      software application.
      {' '}
      <strong><u>Boost Your Super</u></strong>
      {' '}
      will notify us and we will act on your instructions; OR
    </p>

    <p>
      (ii) to cancel your Direct Debit Request, notify us directly via
      email to: helpdesk+BoostYourSuper@hellozai.com or by mail to: Zai
      Australia Pty Ltd, Attention: Boost Your Super Support Team, The
      Commons, Level 1, 55 Collins Street, Melbourne, VIC 3000
    </p>

    <p>
      You can also contact your own financial institution, which must act
      promptly on your instructions.
    </p>

    <h3>Your obligations</h3>

    <p>
      4.1 It is your responsibility to ensure that there are sufficient
      clear funds available in your account to allow a debit payment to be
      made in accordance with the Direct Debit Request.
    </p>

    <p>
      4.2 If there are insufficient clear funds in your account to meet a
      debit payment:
    </p>

    <p>(a) you may be charged a fee and/or interest by your financial institution;</p>
    <p>
      (b) we may charge you reasonable costs incurred by us on account of
      there being insufficient funds; and
    </p>
    <p>
      (c) you must arrange for the debit payment to be made by another
      method or arrange for sufficient clear funds to be in your account by
      an agreed time so that we can process the debit payment.
    </p>

    <p>
      4.3 You should check your account statement to verify that the
      amounts debited from your account are correct.
    </p>

    <h3>Dispute</h3>

    <p>
      5.1 If you believe that there has been an error in debiting your
      account, you should notify us directly at
      {' '}
      helpdesk+BoostYourSuper@hellozai.com
      {' '}
      or by mail to: Zai Australia Pty Ltd, Attention: Boost Your Super
      Support Team, The Commons, Level 1, 55 Collins Street, Melbourne VIC
      3000. Alternatively, you can contact your financial institution
      and/or
      {' '}
      <strong><u>Boost Your Super</u></strong>
      {' '}
      assistance.
    </p>

    <p>
      5.2 If we conclude as a result of our investigations that your
      account has been incorrectly debited we will respond to your query by
      arranging within a reasonable period, for your financial institution
      to adjust your account (including interest and charges) accordingly.
      We will also notify you in writing of the amount by which your
      account has been adjusted.
    </p>

    <p>
      5.3 If we conclude as a result of our investigations that your
      account has not been incorrectly debited we will respond to your
      query by providing you with reasons and any evidence for this finding
      in writing.
    </p>

    <h3>Accounts</h3>

    <p>6.1 You should check:</p>

    <p>
      (a) with your financial institution whether direct debiting is
      available from your account as direct debiting is not available on
      all accounts offered by financial institutions.
    </p>

    <p>
      (b) your account details which you have provided to us are correct by
      checking them against a recent account statement; and
    </p>

    <p>
      (c) with your financial institution before completing the Direct
      Debit Request if you have any queries about how to complete the
      Direct Debit Request.
    </p>

    <p>
      6.2 While the account you nominate for this purpose may be jointly
      held by more parties than those signing the Direct Debit Request, you
      must nominate an account that your Financial Institution permits you
      to operate including the permission to authorise the debiting of that
      account, without your Financial Institution requiring additional
      party to also authorise such debit payments.
    </p>

    <p>
      6.3 If you have identified yourself as an individual only in the
      Direct Debit Request, for the purposes of the Direct Debit Request,
      you may not nominate an Account issued to or operated by a company or
      another similar type of entity structure, such as a Trust.
    </p>

    <h3>Confidentiality</h3>

    <p>
      7.1 We will keep any information (including your account details) in
      your Direct Debit Request confidential. We will make reasonable
      efforts to keep any such information that we have about you secure
      and to ensure that any of our employees or agents who have access to
      information about you do not make any unauthorised use, modification,
      reproduction or disclosure of that information.
    </p>

    <p>7.2 We will only disclose information that we have about you:</p>

    <p>(a) to the extent specifically required by law; or</p>
    <p>
      (b) for the purposes of this agreement (including disclosing
      information in connection with any query or claim).
    </p>

    <h3>Notice</h3>

    <p>
      8.1 If you wish to notify us in writing about anything relating to
      this agreement, you should email us at
      {' '}
      helpdesk+BoostYourSuper@hellozai.com
      {' '}
      or mail us at: Zai Australia Pty Ltd, Attention: Boost Your Super
      Support Team, The Commons, Level 1, 55 Collins Street, Melbourne VIC
      3000.
    </p>

    <p>
      8.2 We will notify you by sending a notice to the preferred contact
      method you have given us in the Direct Debit Request.
    </p>

    <p>
      8.3 Any notice will be deemed to have been received on the second
      banking day after sending if sent via email, or on the fifth banking
      day if sent via post.
    </p>
  </DirectDebitRequestServiceAgreementTextWrapper>
);

export default DirectDebitRequestServiceAgreementText;
